import apiClient from '@/services/api-client';

export default {
	acceptTermsOfUseFirstTime() {
		return apiClient().post('/FirstTimeUser/AcceptTermsOfUseFirstTime');
	},
};
